"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("./styles");
var Label = function (_a) {
    var children = _a.children, required = _a.required, validated = _a.validated, htmlFor = _a.htmlFor;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledLabel, __assign({ className: (0, classnames_1.default)({ validated: validated }), htmlFor: htmlFor, "aria-required": required ? 'true' : undefined }, { children: [children, required && ' *'] })));
};
exports.default = Label;
